import Countdown from '@jsclasses/countdown';

export function initCountdowns() {
  const countdowns = document.querySelectorAll('.js-countdown');

  countdowns.forEach((countdown) => {
    const startAt = countdown.dataset.start;
    const endAt = countdown.dataset.end;
    const showDays = countdown.dataset.showDays === 'true';
    const showLabels = countdown.dataset.showLabels === 'true';
    const type = countdown.dataset.type || 'normal';
    const labels = countdown.dataset.labels
      ? JSON.parse(countdown.dataset.labels)
      : {};

    new Countdown(
      countdown,
      startAt,
      endAt,
      showDays,
      showLabels,
      type,
      labels
    );
  });
}
